import { ActivationCostsItem, CardItem, PaymentFeesItem, ShippingItem } from "./types/shoppingCart";

export function calculatePaymentFees(cartItems: (CardItem | ShippingItem | PaymentFeesItem | ActivationCostsItem)[]): number {
    let paymentFees = 0;
    const orderTotal = cartItems.reduce((sum, item: CardItem | ShippingItem | PaymentFeesItem | ActivationCostsItem) => item.type === 'card' || item.type === 'shipping' || item.type === 'activationCosts' ? sum + item.price * item.quantity : sum, 0);
    console.log({ orderTotal })
    paymentFees = (Math.ceil((orderTotal * 1.1) / 5) * 5) - orderTotal;
    return parseFloat(paymentFees.toFixed(2));
}